// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import PickLineController from "./pick_line_controller"
application.register("pick-line", PickLineController)

import SortFormController from "./sort_form_controller"
application.register("sort-form", SortFormController)
